// Function to perform a flexible string search
export default function flexibleSearch(query, target) {
    // Convert both query and target to lowercase for case-insensitive matching
    if (query == null || target == null){
        return -1.0;
    }
    
    query = query.toLowerCase();
    target = target.toLowerCase();

    /*
    // Check if the target contains the entire query as a substring
    if (target.includes(query)) {
        return 1.0;
    }
    */

    // Check if any substring of the target closely matches the query using fuzzy matching
    const targetWords = target.split(/\s+/); // Split target into words
    const queryWords = query.split(/\s+/);   // Split query into words

    let highestSim = 0;
    /*

    for (const queryWord of queryWords) {
        for (const targetWord of targetWords) {
            // Use a fuzzy matching algorithm (e.g., Levenshtein distance) to determine similarity
            const similarity = computeSimilarity(queryWord, targetWord);
            if (similarity >= highestSim) {
                highestSim = similarity;
            }
        }
    }
    */

    highestSim = computeSimilarity(query, target);

    return highestSim;
}

// Function to compute similarity between two words (e.g., using Levenshtein distance)
function computeSimilarity(word1, word2) {
    
    word1 = normalizeToBase(word1);
    word2 = normalizeToBase(word2);
    
    // Levenshtein distance
    const dp = Array.from({ length: word1.length + 1 }, (_, i) => i);
    for (let i = 1; i <= word2.length; i++) {
        let prev = dp[0]++;
        for (let j = 1; j <= word1.length; j++) {
            const temp = dp[j];

            //Added due to Yoruba special characters
            let eqChars = word1[j - 1] == word2[i - 1];
            
            dp[j] = eqChars ? prev : Math.min(prev + 1, Math.min(dp[j] + 1, dp[j - 1] + 1));
            prev = temp;
        }
    }
    return 1 - dp[word1.length] / Math.max(word1.length, word2.length);
}

// Turns accented string into base strings
function normalizeToBase(inputString) {
    if (typeof inputString !== 'string') {
      return ""; // Handle non-string inputs gracefully
    }
  
    // Normalize the string to NFD (Normalization Form Decomposition)
    const normalizedString = inputString.normalize('NFD');
  
    // Use a regular expression to remove combining diacritical marks (accent marks)
    const baseString = normalizedString.replace(/[\u0300-\u036f]/g, '');
  
    return baseString.toLowerCase();
}